import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import { GET_EVENT_REFUND_STATUS } from './useGetRefundStatus';

export const REFUND_PASSES = gql`
  mutation RefundPasses($input: CreateTransactionCreditInput) {
    createRefundV3(input: $input)
  }
`;

export function useRefundPasses() {
  const [refundPassesMutation] = useMutation(REFUND_PASSES);

  const refundPasses = useCallback(
    (
      pass_ids,
      event_id,
      transaction_id,
      include_fees,
      credit_amount,
      message,
      template_context
    ) => {
      const input = {
        pass_ids: [...pass_ids],
        transaction_id,
        include_fees,
        credit_amount,
        message: message || null,
      };

      // Only add templateContext if it exists
      if (template_context) {
        input.templateContext = template_context;
      }

      const mutationOptions = {
        variables: {
          input,
        },
      };

      // Only refetch event status if we have an event_id
      if (event_id) {
        mutationOptions.refetchQueries = [
          {
            query: GET_EVENT_REFUND_STATUS,
            variables: {
              event_id,
            },
          },
        ];
      }

      return refundPassesMutation(mutationOptions);
    },
    [refundPassesMutation]
  );
  return refundPasses;
}
